import React, { ReactNode, useEffect, useState } from 'react';
import Footer from '../Footer';
import Header from '../Header';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

function Layout({
  children,
  themeToggler,
}: {
  children: ReactNode;
  themeToggler: () => void;
}) {
  const [noheader, setNoHeader] = useState(false);
  const [nofooter, setNoFooter] = useState(false);
  const [smallHeader, setSmallHeader] = useState(false);
  const [noFloat, setNoFloat] = useState(false);
  const [noPadding, setNoPadding] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split('/')[1] || '';

    // 기본값 초기화: 헤더/푸터 노출, 기본 헤더 사이즈, 플로팅/패딩 허용
    setNoHeader(false);
    setNoFooter(false);
    setSmallHeader(false);
    setNoFloat(false);
    setNoPadding(false);

    // 차트 화면: 헤더/푸터 모두 숨김
    if (path.includes('chart')) {
      setNoHeader(true);
      setNoFooter(true);
      return;
    }

    // 트레이드 화면: 푸터 숨김, 컴팩트 헤더 및 패딩 조정
    if ((path.startsWith('trade') || path.includes('demo-trade')) && !path.includes('copytrade')) {
      setSmallHeader(true);
      setNoFloat(false);
      setNoFooter(true);
      setNoPadding(true);
      return;
    }
  }, [location.pathname]);

  return (
    <GlobalContainer>
      {!noheader && (
        <Header
          themeToggler={themeToggler}
          smallHeader={smallHeader}
          noFloat={noFloat}
          noPadding={noPadding}
        />
      )}
      {children}
      {!nofooter && <Footer themeToggler={themeToggler} />}
    </GlobalContainer>
  );
}

export default React.memo(Layout);

const GlobalContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;
